import {User} from '@perfectpost/perfect-post-common';
import {Locale, format as dateFnsFormat, parseISO, formatRelative, formatDistanceToNow} from 'date-fns';
import {enUS, es, fr, it, pt, de} from 'date-fns/locale';

const locales: {[key in User['locale']]: Locale} = {
  en: enUS,
  fr,
  es,
  it,
  pt,
  de,
};

export function localFormat(date: number | Date, format: string, locale?: User['locale']) {
  return dateFnsFormat(date, format, {locale: locales[locale ?? 'en']});
}

export function localFormatISOString(date: string, format: string, locale?: User['locale']) {
  return dateFnsFormat(parseISO(date), format, {locale: locales[locale ?? 'en']});
}

export function localFormatRelativeISOString(date: string, locale?: User['locale']) {
  return formatRelative(parseISO(date), new Date(), {locale: locales[locale ?? 'en']});
}

/** Distance relative à maintenant, localisée : « il y a 2 heures », « 2 hours ago »… */
export function localFormatDistanceToNowISOString(date: string, locale?: User['locale']) {
  return formatDistanceToNow(parseISO(date), {locale: locales[locale ?? 'en'], addSuffix: true});
}
